import { browser } from '$app/environment';
import { PUBLIC_UMAMI_URL, PUBLIC_UMAMI_WEBSITE_ID } from '$env/static/public';
import {
    cookie_consent_statistics,
    isProd,
    site_origin
} from '$lib/stores/globals';
import { get } from 'svelte/store';

let is_installed = false;
let tried_to_install = false;

const params_of_interest = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'ref',
    'z'
];

/** @type {{name:string, data:{}}[]} */
let event_queue = [];

/** @type {Record<string, string>} */
let params_of_interest_session = {};

export function install() {
    if (!browser || !isProd) return;

    save_params_of_interest();

    if (is_installed || tried_to_install) return;
    tried_to_install = true;
    performInstall();
}

function performInstall() {
    let d = document;
    let s = d.createElement('script');
    s.async = true;
    s.defer = true;

    s.onload = () => {
        is_installed = true;

        event_queue.forEach((e) => {
            track_event(e.name, e.data);
        });
        event_queue = [];
    };

    s.setAttribute('data-website-id', PUBLIC_UMAMI_WEBSITE_ID);
    s.setAttribute('src', PUBLIC_UMAMI_URL);
    d.body.appendChild(s);
}

function track_event(name, data) {
    try {
        window.umami.track(name, data);
    } catch (e) {
        console.error('Error logging event', e);
    }
}

export function logEvent(name = '', data = {}) {
    if (!browser) {
        return;
    }

    save_params_of_interest();
    const data_params = get_umami_params_of_interest();
    const event_data = { ...data, ...data_params };

    if (!isProd) {
        console.log('log_event', name, data, data_params);
        return;
    }

    if (is_installed) {
        track_event(name, event_data);
    } else {
        event_queue.push({ name, data: event_data });
    }

    install();
}

const normalize_referrer = (referrer) => {
    if (!referrer) return '';
    const referrer_url = new URL(referrer);
    const ref_path =
        referrer_url.origin === site_origin ? '' : referrer_url.hostname;

    let ret = ref_path;

    if (ref_path.includes('.google.')) ret = 'google';
    else if (ref_path.includes('.facebook.')) ret = 'facebook';
    else if (ref_path.includes('.twitter.')) ret = 'twitter';
    else if (ref_path.includes('.reddit.')) ret = 'reddit';
    else if (ref_path.includes('.bing.')) ret = 'bing';
    else if (ref_path.includes('.yahoo.')) ret = 'yahoo';

    return ret;
};
export const save_params_of_interest = () => {
    if (!browser) return;

    const new_params = new URLSearchParams(location.search);
    let new_params_obj = {};
    for (let param of params_of_interest) {
        if (new_params.get(param))
            new_params_obj[param] = new_params.get(param);
    }

    if (document.referrer) {
        new_params_obj['doc_referrer'] = normalize_referrer(document.referrer);
    }

    if (!new_params_obj['utm_source']) {
        if (new_params.get('fbclid')) new_params_obj['utm_source'] = 'facebook';
        else if (new_params.get('gclid'))
            new_params_obj['utm_source'] = 'google';
        else if (new_params.get('twclid'))
            new_params_obj['utm_source'] = 'twitter';
    }

    params_of_interest_session = {
        ...params_of_interest_session,
        ...new_params_obj
    };
};

export const get_params_of_interest = () => {
    if (!browser) return {};

    save_params_of_interest();
    return { ...params_of_interest_session };
};

const get_umami_params_of_interest = () => {
    if (!get(cookie_consent_statistics)) return {};

    return get_params_of_interest();
};

export const track_purchase = (price) => {
    if (!isProd) {
        console.log('track_purchase', price);
        return;
    }

    if (typeof window.fbq === 'function')
        window.fbq('track', 'Purchase', {
            value: price,
            currency: 'USD'
        });

    if (typeof window.twq === 'function')
        window.twq('event', 'tw-onejy-onek0', {
            value: price,
            currency: 'USD'
        });
};

export const track_initiate_checkout = () => {
    if (!isProd) {
        console.log('track_initiate_checkout');
        return;
    }

    if (window?.fbq) window?.fbq('track', 'InitiateCheckout');
    //this is made up
    // if (window?.twq) window?.twq('track', 'InitiateCheckout');
};

export const add_param_of_interest = (key, value) => {
    if (!browser) return;

    params_of_interest_session = {
        ...params_of_interest_session,
        [key]: value
    };
};
